export const ApiCreateSpaceTag = Symbol('ApiCreateSpaceTag');
